module.exports = __webpack_public_path__ + "static/award-appstore-6ad92e501a2536b6553b7b4fc62bcfb4.svg";